import { Flex } from 'antd';
import AIIcon from 'Assets/icons/icon-ai.svg';

import styles from './AINoteButton.less';

interface AINoteButtonProps {
  onClick?: () => void;
  buttonText?: string;
}

const AINoteButton = ({ buttonText, onClick }: AINoteButtonProps) => {
  return (
    <button type="button" className={styles.aiNoteButton} onClick={onClick}>
      <Flex gap={8} align="center" className={styles.aiNoteButtonContent}>
        <img src={AIIcon} alt="AI Icon" />
        <div className={styles.text}>{buttonText}</div>
      </Flex>
    </button>
  );
};

export default AINoteButton;
